export default __webpack_public_path__ + "static/media/tamirRice.61159202.png";